// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"daafdf8b","98":"bc301a53","150":"2282e38e","191":"378b490c","388":"8e1e7bb2","488":"4fc9d785","521":"313f2a62","523":"947ef36f","591":"c7b1659f","604":"9600b06b","625":"78ce2315","927":"285549f9","940":"78179f91","942":"b41e59a4","956":"d33e6cba","995":"e383a965"}[chunkId] + ".chunk.js";
};